import './css/form.css'
import request from 'superagent';
import React, { Component } from 'react';
import { Loader, Responsive, Icon, TextArea, Radio, Checkbox, Dropdown, Header, Button, Form, Input, Step } from 'semantic-ui-react'


function validate(d, type) {

	if (!d || d == "") return false;
	return true;
}

function validateEmail(email) {
	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(String(email).toLowerCase());
}

class MyStep extends Component {

	constructor() {
		super();
		this.onChange = this.onChange.bind(this);
	}

	onChange(e, data) {


		let o = {};
		if (data.type == "checkbox") {
			o[data.name] = data.checked ? true : null;
		} else {
			o[data.name] = data.value;
		}

		this.props.onChanged(o);

	}

}


class StepActividad extends MyStep {

	render() {

		return (
			<Form>

				<Form.Input fluid label='Nombre' placeholder='Nombre de la actividad' defaultValue={this.props.state.formData["actividad_nombre"]} onChange={this.onChange} name="actividad_nombre" required />


				<Form.Field required>
					<label className="required" data-type="textarea">Descripción del servicio</label>
					<TextArea defaultValue={this.props.state.formData["actividad_descripcion"]} onChange={this.onChange} className="form-control" name="actividad_descripcion" rows="4" />
				</Form.Field>


				<Form.Field>
					<label>Categoría</label>
					{
						['Distribuidor', 'Productor', 'Servicios'].map(d => (
							<Radio key={d} checked={this.props.state.formData["actividad_categoria"] === d} onChange={this.onChange} name="actividad_categoria" label={d} value={d} />
						))
					}
				</Form.Field>


				<Form.Field>
					<label><b>Tiene certificación?</b></label>
					{
						['CRAE', 'otra'].map(d => (
							<Radio key={d} checked={this.props.state.formData["actividad_certification"] === d} onChange={this.onChange} name="actividad_certification" label={d} value={d} />
						))
					}
				</Form.Field>


			</Form>
		)
	}
}


class StepContactos extends MyStep {

	render() {
		return (
			<Form>

				<Form.Field>
					<Form.Input fluid label='Direccion' disabled={this.props.state.formData["nodireccion"]} defaultValue={this.props.state.formData["actividad_direccion"]} onChange={this.onChange} name="actividad_direccion" required />

					<Checkbox value='nodireccion' name="nodireccion" onChange={(a, b) => {
						this.onChange(null, {
							name: "nodireccion",
							value: b.checked
						})
					}} label="No tiene dirección fisica" />
				</Form.Field>



				<Form.Field>
					<label>Correo electrónico
			<Form.Input defaultValue={this.props.state.formData["actividad_correo"]} onChange={this.onChange} name="actividad_correo" error={
							this.props.state.formData["actividad_correo"] && !validateEmail(this.props.state.formData["actividad_correo"]) ? true : null
						} />
					</label>
				</Form.Field>

				<Form.Field>
					<label>Web
			<Input defaultValue={this.props.state.formData["actividad_web"]} onChange={this.onChange} name="actividad_web" />
					</label>


				</Form.Field>

				<Form.Field>
					<label>Teléfono
			<Input defaultValue={this.props.state.formData["actividad_telefono"]} onChange={this.onChange} name="actividad_telefono" />
					</label>
				</Form.Field>

			</Form>
		)
	}
}


class StepDetalles extends MyStep {

	constructor(props) {
		super(props);
		this.onChange = this.onChange.bind(this);
		let hours = [];
		for (let i = 6; i < 24; i++) {
			for (let j = 0; j < 2; j++) {
				hours.push((i < 10 ? "0" + i : i) + ":" + (j === 0 ? "00" : 30 * j));
			}
		}
		hours = hours.map((d, i) => { return { text: d, value: d } });
		hours.unshift({ text: "Cerrado", value: "Cerrado" });

		this.days = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'].map(d => {
			return {
				day: d,
				opening: "09:30",
				closure: "18:30",
				hours
			}
		})
		this.state = {};
		this.state.days = this.days;

	}

	onChangeHours(value, day, isOpening) {
		this.days.forEach(d => {

			if (d.day === day) {
				d[isOpening ? "opening" : "closure"] = value;
			}
		})

		let data = {
			name: "days",
			value: this.days.map(d => {
				return {
					day: d.day,
					opening: d.opening,
					closure: d.closure
				}
			})
		}

		this.onChange(null, data);
		this.setState({
			days: this.days,
			isSpecified: false
		})
	}

	getHoursSelect(day, isOpening, value, hours) {

		return (
			<Dropdown scrolling onChange={(event, data) => { this.onChangeHours(data.value, day, isOpening === true) }} options={hours} defaultValue={value} />
		);
	}

	render() {


		let daysDivs = this.days.map((d, i) => (
			<tr key={i}>
				<td>{d.day}</td>
				<td>{this.getHoursSelect(d.day, true, d.opening, d.hours)}</td>
				<td>{this.getHoursSelect(d.day, false, d.closure, d.hours)}</td>
			</tr>
		))
		return (

			<Form>

				<Form.Checkbox onChange={(a, b) => this.setState({ isSpecified: b.checked })}
					label="Marca la casilla si quieres especificar tus horarios de atención al público" />

				{this.state.isSpecified &&
					<Form.Field>
						<table>
							<thead>
								<tr>
									<td>Día</td>
									<td>De las</td>
									<td>Hasta las</td>
								</tr>
							</thead>
							<tbody>
								{daysDivs}
							</tbody>
						</table>
					</Form.Field>
				}

			</Form>


		)
	}
}

class StepTu extends MyStep {
	constructor(props) {
		super(props);
		this.onChange = this.onChange.bind(this);
		this.data = {};
	}

	render() {

		return (

			<Form>

				<Form.Input fluid label='Nombre' defaultValue={this.props.state.formData["user_nombre"]} onChange={this.onChange} name="user_nombre" required />

				<Form.Input fluid label='Correo electrónico' defaultValue={this.props.state.formData["user_correo"]} onChange={this.onChange} name="user_correo" error={
					this.props.state.formData["user_correo"] && !validateEmail(this.props.state.formData["user_correo"]) ? true : null
				} required />

				<Form.Field>
					<Checkbox onChange={this.onChange} value="esDueno" name="esdueno" label="Soy el dueño" />
				</Form.Field>
				<Form.Field	>
					<Checkbox onChange={this.onChange} value="esDueno" name="authorizo" label="Autorizo a Grancanariaecologica.es a que utilice la información que proporciono en este formulario para mantenerme al día de sus novedades a través de correo electrónico y publicar informaciones sobre mi actividad según cuanto descrito en los (Términos y Condiciones) del Servicio." />
				</Form.Field>

			</Form>
		)
	}
}


export default class MyForm extends Component {

	constructor(props) {
		super(props);

		this.onChanged = this.onChanged.bind(this)

		this.state = {
			complete: false,
			formData: {},
			hasSent: false,
			isSending: false,
			currentStep: 0
		}

		this.labels = ["Actividad", "Contactos", "Detalles", "Tu"];
		this.labels.forEach(d => {
			this.state[d] = false;
		})



	}

	restart() {
		this.setState({

			hasSent: false,
			currentStep: 0
		});
	}

	next() {
		this.setState({
			currentStep: this.state.currentStep + 1
		});
	}

	previous() {
		this.setState({
			currentStep: this.state.currentStep - 1
		});
	}

	linkClicked(e, i) {
		e.preventDefault();
		this.setState({
			currentStep: i
		});
	}


	onChanged(e) {

		let formData = Object.assign({}, this.state.formData);
		for (var i in e) {
			formData[i] = e[i];
		}

		console.log(formData);

		this.setState({
			formData,
			["Actividad"]: validate(formData["actividad_nombre"]) && validate(formData["actividad_descripcion"]),
			["Contactos"]: validate(formData["actividad_direccion"]) || formData["nodireccion"],
			["Tu"]: formData["user_nombre"] != null && validateEmail(formData["user_correo"])
		})



	}


	renderInnerForm() {

		let stepSize = window.innerWidth < 700 ? "tiny" : "small";
		return (
			<div>

				<Responsive maxWidth="768" as={() => (
					<Header as='h4'>{this.labels[this.state.currentStep]}</Header>
				)} />

				<Responsive minWidth="768">
					<Step.Group size={stepSize} style={{ marginBottom: "1rem" }} unstackable>
						{
							this.labels.map((label, i) => (
								<Step onClick={(e) => this.linkClicked(e, i)} key={i} active={i == this.state.currentStep} >
									<Icon style={{ fontSize: ".9rem", opacity: this.state[label] ? 1 : .3 }} name={this.state[label] ? "check" : ""} />
									{"  " + label}
								</Step>

							))
						}
					</Step.Group>
				</Responsive>

			</div>
		)
	}


	getStep() {
		switch (this.state.currentStep) {
			case 0:
				return <StepActividad state={this.state} label={this.labels[this.state.currentStep]} onChanged={this.onChanged} />;
			case 1:
				return <StepContactos state={this.state} label={this.labels[this.state.currentStep]} onChanged={this.onChanged} />;
			case 2:
				return <StepDetalles state={this.state} label={this.labels[this.state.currentStep]} onChanged={this.onChanged} />;
			case 3:
				return <StepTu state={this.state} label={this.labels[this.state.currentStep]} onChanged={this.onChanged} />;
		}
	}

	sendRequest() {
		this.setState({
			isSending: true
		})
		request.post('php/mail.php')
			.send({ data: this.state.formData })
			.end((response) => {
				this.setState({
					response,
					hasSent: true,
					isSending: false
				})
			})
	}

	renderEnd() {
		console.log(this.state.response);

		if (this.state.hasSent) {
			return (
				<div>
					<p>Gracias!</p>
					<Button onClick={this.restart.bind(this)}>Vuelve al Mapa</Button>
				</div>
			)

		} else {
			<div>
				<Loader />
				<p>Transmitiendo tus datos...</p>
			</div>
		}
	}


	renderForm() {

		let isComplete = this.state["Actividad"] && this.state["Contactos"] && this.state["Tu"];

		return (
			<div>
				{this.renderInnerForm()}
				{this.getStep()}

				<div style={{ marginTop: "3rem", display: "flex", justifyContent: "space-between" }}>
					<Form.Field>
						{this.state.currentStep > 0 && <Button onClick={this.previous.bind(this)}>anterior</Button>}
						{this.state.currentStep < 3 && <Button onClick={this.next.bind(this)}>siguiente</Button>}
					</Form.Field>
					<Form.Field>
						{this.state.currentStep == 3 && <Button onClick={this.sendRequest.bind(this)} disabled={!isComplete} >enviar</Button>}
					</Form.Field>
				</div>

			</div>

		)
	}

	render() {

		return (
			<div id="myform">
				<div style={{ display: "flex", justifyContent: "space-between" }}>
					<h2 style={{ marginBottom: "2rem" }}>Agrega un nuevo lugar </h2>

					<Responsive minWidth="768">
						<a href="#" onClick={(e) => {
							e.preventDefault();
							this.props.history.push("/");
						}}>
							<Icon name='up arrow' />Vuelve al listado</a>
					</Responsive>
				</div>

				{this.state.isSending || this.state.hasSent ? this.renderEnd() : this.renderForm()}


			</div>

		)

	}


}


// WEBPACK FOOTER //
// ./src/MyForm.js